import { ntc } from 'src/explore/services/currency_helper';

const format = ( value ) => ntc( value, { verbose: false });

export default {
  format,
};
